import { useEffect, useState } from "react";
import { Repeat, Loader2, Play, Pause } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function AdminSubscriptions() {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/recurring/subscriptions");
      setSubs(data);
    } catch {
      toast.error("Could not load subscriptions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const toggle = async (id) => {
    try {
      const { data } = await api.post(`/recurring/subscriptions/${id}/pause`);
      toast.success(data.active ? "Plan resumed" : "Plan paused");
      await load();
    } catch {
      toast.error("Could not update plan");
    }
  };

  return (
    <div data-testid="admin-subscriptions-page">
      <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#ff6b00] flex items-center gap-2"><Repeat className="h-3.5 w-3.5" /> Recurring</div>
      <h1 className="font-display uppercase text-3xl font-extrabold text-slate-100 mt-2">Maintenance Plans</h1>
      <p className="text-sm text-slate-400 mt-1">Customers on auto-rebooking. We email them to confirm each visit before any deposit is taken.</p>

      {loading ? (
        <div className="mt-10 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-500" /></div>
      ) : subs.length === 0 ? (
        <div className="mt-10 text-slate-500 text-sm" data-testid="subs-empty">No recurring customers yet.</div>
      ) : (
        <div className="mt-6 grid gap-3">
          {subs.map((s) => (
            <div key={s.id} data-testid={`sub-row-${s.id}`} className="cj-card p-4 flex flex-wrap items-center justify-between gap-4">
              <div>
                <div className="font-display font-bold text-slate-100">{s.customer?.name}</div>
                <div className="font-mono text-[11px] text-slate-500 mt-0.5">{s.customer?.email} · {s.customer?.phone}</div>
                <div className="text-sm text-slate-300 mt-1">{s.plan_label} <span className="text-slate-500">· {s.cadence}</span></div>
                <div className="text-xs text-slate-500 mt-0.5">Next visit: {s.next_date}</div>
              </div>
              <div className="flex items-center gap-3">
                <span className={`cj-pill text-[10px] ${s.active ? "bg-emerald-500/10 text-emerald-300 border border-emerald-500/30" : "bg-slate-500/10 text-slate-400 border border-slate-500/30"}`}>{s.active ? "Active" : "Paused"}</span>
                <button onClick={() => toggle(s.id)} data-testid={`sub-toggle-${s.id}`} className="cj-btn-ghost px-4 py-2 rounded-full text-xs inline-flex items-center gap-1">
                  {s.active ? <><Pause className="h-3.5 w-3.5" /> Pause</> : <><Play className="h-3.5 w-3.5" /> Resume</>}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
